"use client"

import { useEffect, useState } from "react"
import Link from "next/link"
import { api } from "@/lib/api"

/**
 * Footer-Link zur Aktionen-Seite — nur sichtbar, wenn die Seite aktiv ist.
 * Bewusst client-seitig geprüft: der Footer steckt in statisch gebauten Seiten,
 * deren Server-Cache erst beim Redeploy erneuert würde. So wirkt der Admin-
 * Schalter promotions.pageEnabled sofort beim nächsten Seitenaufruf.
 */
export default function FooterPromoLink() {
  const [enabled, setEnabled] = useState(false)
  useEffect(() => {
    api.getPromotions().then((r) => setEnabled(!!r?.enabled)).catch(() => {})
  }, [])

  if (!enabled) return null
  return (
    <Link href="/aktionen" className="text-sm font-medium text-[var(--main-color)] hover:opacity-80 transition-opacity">
      Aktionen
    </Link>
  )
}
